import { Component, computed, effect, inject, model, signal, untracked } from '@angular/core';
import { FairBanner } from '../../../../shared/models/banner.models';
import { Advertise } from "../../../../shared/components/advertise/advertise";
import { PromotionalBanner, ImgVersionParams} from '../../../../core/layouts/utils/promotional-banner';
import { SharedService } from '../../services/shared.service';
import { DeviceDetectionService } from '../../../../core/services/device-detection';
import { FairService } from '../../../../shared/services/fair.service';
import { toSignal } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-ads-panel',
  imports: [Advertise],
  templateUrl: './ads-panel.html',
  styleUrl: './ads-panel.scss'
})
export class AdsPanel {
  private sharedService = inject(SharedService)
  private deviceDetectionService = inject(DeviceDetectionService)
  private fairService = inject(FairService);
  openBannerPop = model<FairBanner | null | boolean>(null)
  promotionalBanner = signal<PromotionalBanner>({} as PromotionalBanner);
  proBanner = signal<PromotionalBanner>({} as PromotionalBanner);
  showBanner = signal(false);
  showPopup = signal(false);
  popupClosedByUser = signal(false);
  imgVersionParams = ImgVersionParams
  resolvedPopupBanner = computed(() => {
    const openPop = this.openBannerPop();
    const popUp = this.popUpBanner();
    if (openPop !== null && typeof openPop === 'object') {
       return openPop as FairBanner;
    }
    return popUp;
  });
  
  isAppliedFilter = computed(() => this.sharedService.isAppliedFilter());
  isMobileDevice = computed(() => this.deviceDetectionService.isMobileOrTablet());

  rightSidePanel = toSignal(
    this.fairService.rightBanner$,
    {initialValue: null}
  )

  popUpBanner = toSignal(
    this.fairService.popBanner$,
    {initialValue: null}
  )

  constructor(){
    effect(() => {
      const openPop = this.openBannerPop();
      if (openPop !== null && typeof openPop === 'object') {
        untracked(() => {
          this.popupClosedByUser.set(false);
        });
      }

      const banner = this.resolvedPopupBanner();
      if (banner !== null && !this.popupClosedByUser()) {
        const isMobile = this.isMobileDevice();
        const openPopIsBanner =
          openPop !== null && typeof openPop === 'object';
        if (!isMobile || (isMobile && this.isAppliedFilter() && openPopIsBanner)) {
          this.showPopup.set(true);
          
          if (isMobile) {
             untracked(() => {
               this.sharedService.updateIsAdsPopOpen(true);
             });
          }
        }
      }
    });
  }

  closePop():void{
    this.popupClosedByUser.set(true);
    this.showPopup.set(false);
    this.openBannerPop.set(false);
    if(this.isMobileDevice()){
      this.sharedService.updateIsAdsPopOpen(false)
      this.sharedService.updateIsAppliedFilter(!this.isAppliedFilter());
    }
  }

  redirectFromPop(url:string):void{
    if(typeof url === 'string' && url.trim() === ''){
      return;
    }
    window.open(url, '_blank')
  }

}
